import {
  ToggleGroup,
  ToggleGroupItem,
} from "@volca/ui/components/ui/toggle-group";
import { PACK_CHAT_STATUS } from "@/payroll/pack-chat/types";

export const THREAD_FILTER = {
  all: "all",
  open: PACK_CHAT_STATUS.open,
  closed: PACK_CHAT_STATUS.closed,
} as const;

export type ThreadFilter = (typeof THREAD_FILTER)[keyof typeof THREAD_FILTER];

const FILTER_LABELS: Record<ThreadFilter, string> = {
  [THREAD_FILTER.all]: "All",
  [THREAD_FILTER.open]: "Open",
  [THREAD_FILTER.closed]: "Closed",
};

export const PackChatThreadFilter = ({
  value,
  counts,
  onChange,
}: {
  value: ThreadFilter;
  counts: Record<ThreadFilter, number>;
  onChange: (next: ThreadFilter) => void;
}) => (
  <ToggleGroup
    size="sm"
    spacing={1}
    className="flex-wrap"
    value={[value]}
    onValueChange={(next) => {
      const picked = Object.values(THREAD_FILTER).find(
        (filter) => filter === next[0],
      );
      if (picked) onChange(picked);
    }}
    aria-label="Filter threads by status"
  >
    {Object.values(THREAD_FILTER).map((filter) => (
      <ToggleGroupItem key={filter} value={filter}>
        {FILTER_LABELS[filter]}
        <span className="text-subtle">{counts[filter]}</span>
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);
